import type { FunnelStage } from '@/types/report.types';

export interface FunnelTableCell {
  stage: string;
  count: number;
}

/**
 * Aligns a breakdown row's stage counts to the table's column order. The API
 * only returns stages a category actually has, so cells must be matched to
 * columns by stage key — positional rendering shifts counts under the wrong
 * headers whenever orders differ or a stage is missing.
 */
export function alignStagesToColumns(columns: FunnelStage[], stages: FunnelStage[]): FunnelTableCell[] {
  return columns.map((column) => ({
    stage: column.stage,
    count: stages.find((stage) => stage.stage === column.stage)?.count ?? 0,
  }));
}
